// extracted by mini-css-extract-plugin
module.exports = {"titles":"HeroBannerPromoGeneral_titles__TO0DL","titlesWrapper":"HeroBannerPromoGeneral_titlesWrapper__kN9w_"};